module.exports = __webpack_public_path__ + "popup-prompt-example.png?6a97abb5d218cac9e4a5564c85d73926";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup-prompt-example.png
// module id = 11
// module chunks = 0